import useGlobalStore from '../store/globalStore'
import {nextTick} from 'vue'
import axios from "axios";

export function useFormSubmit() {
  const globalStore = useGlobalStore()
  const assignHiddenFields = (ele) => {
    globalStore.setModal(
      {
        name: globalStore.modal.name,
        title: globalStore.modal.title,
        id: globalStore.modal.id,
        operatorName: ele.dataset.operatorName,
        operatorId: ele.dataset.operatorId,
        enquiryTypeFull: ele.dataset.enquiryTypeFull,
        subscription: ele.dataset.subscription,
        enquiryRegion: ele.dataset.enquiryRegion,
        enquiryDistrict: ele.dataset.enquiryDistrict,
        homeTypes: ele.dataset.typesOfHomes,
        propertyName: ele.dataset.propertyName,
        enquiryType: ele.dataset.enquiryType,
      }
    )
  }

  const hideModal = () => {
    setTimeout(function () {
      globalStore.setModal(
        {
          name: '',
          id: '',
          title: '',
        }
      )
    }, 4000)

    document.querySelector('body').classList.remove('modal-open', 'stop-scrolling');

    // remove the model from the url
    if (window.location.pathname === '/rest-homes-learn-more') {
      history.pushState(null, null, '/rest-homes-learn-more');
    } else {
      let currentUrl = window.location.href;
      currentUrl = currentUrl.replace('?modal=articlePropertyReportModal', '');
      history.pushState(null, null, `${currentUrl}`);
    }
  }

  const closeModal = () => {
    globalStore.setModal(
      {
        name: '',
        id: '',
        title: '',
      }
    )

    document.querySelector('body').classList.remove('modal-open', 'stop-scrolling');
  }

  const showEventRegisterForm = async (id, e) => {
    const ele = e.target;
    globalStore.setModal(
      {
        name: 'eventRegisterModal',
        title: ele.dataset.villageName,
        id: id,
        eventType: ele.dataset.eventType,
      }
    )

    assignHiddenFields(ele);

    await nextTick()
    document.getElementById('event-title').innerHTML = ele.dataset.eventTitle;
    document.getElementById('event-village-name').href = ele.dataset.villageLink;
    document.getElementById('event-village-name').innerHTML = ele.dataset.villageName;
    document.getElementById('event-type').value = ele.dataset.eventType;
    let eventHeader = '';
    if (ele.dataset.eventType === 'open day') {
      eventHeader = `Learn more about this <br class="d-inline-block d-sm-none" />${ele.dataset.eventType}`;
    } else {
      eventHeader = `Learn more about this ${ele.dataset.eventType}`;
    }
    document.getElementById('event-header').innerHTML = eventHeader;
    document.getElementById('event-summary').innerHTML = `I would like to be sent additional information about this upcoming ${ele.dataset.eventType}.`;
  }

  const blogDownloadForm = async (e) => {
    if (e.target.tagName === 'A') {
      globalStore.setModal(
        {
          name: 'rcDownloadEmail',
          title: e.target.dataset.formTitle,
          customField: e.target.href
        }
      )

      await nextTick()
      document.getElementById('rc-download-description').innerText = e.target.dataset.formDescription;
      document.getElementById('rc-download-image').src = e.target.dataset.formImage;
      document.getElementById('rc-download-image').alt = e.target.dataset.formTitle;
      document.getElementById('rc-download-id').value = e.target.dataset.formId;

      let $wire = Livewire.find('rcDownload');

      if ($wire !== undefined) {
        $wire.articleId = e.target.dataset.formId;
        $wire.fileDownloadLink = e.target.href;
      }
    } else {
      const ele = e.target.closest('a');
      ele.click();
    }
  }

  const showPropertyListModal = async (id, title, e) => {
    globalStore.setModal(
      {
        name: 'propertyListEnquiryModal',
        id: id,
        title: title,
      }
    )

    localStorage.setItem('preSiteTitle', document.title);

    await nextTick()
    const ele = e.target;

    if (e.target.dataset.metaTitle) {
      document.title = e.target.dataset.metaTitle;
    }

    if (e.target.classList.contains('request-pricing')) {
      document.getElementById('pricing-information').checked = true;
    }

    document.getElementById('property_name').value = ele.dataset.propertyName;
    assignHiddenFields(ele);
  }

  const toggleEnquiryForm = async (propertyId, title, modalName = 'propertyEnquiryModal', typeOfHomeName = '', e) => {

    let customField = 'property'
    let placeholder = ''

    if (modalName === 'villageTypesOfHomesModal') {
      customField = 'typesOfHome'
      placeholder = `Please send me more information about ${typeOfHomeName} at ${title}`
    }

    globalStore.setModal(
      {
        name: modalName,
        id: propertyId,
        showFooter: false,
        customField: customField,
        title: `Enquiry about <br> <span>${title}</span>`,
        descriptionPlaceholder: placeholder,
      }
    )

    if (data.showEnquiryId === propertyId) {
      data.showEnquiryId = false;
    } else {
      data.showEnquiryId = propertyId;
    }

    await nextTick()

    const ele = e.target;
    document.getElementById('property_name').value = ele.dataset.propertyName;
    assignHiddenFields(ele);
    const form = document.getElementById('village-common-enquiry-form');

    if (form) {
      form.querySelector('#enquiry_type_full').value = ele.dataset.enquiryTypeFull;
    }
  }

  const toggleModal = (modalName, showFooter) => {
    globalStore.setModal({name: modalName, showFooter: showFooter});

    if (modalName !== 'articleEnquiryModal' && modalName !== 'modalVideo') {
      history.pushState(null, null, `${window.location.href.split('?')[0]}?modal=${modalName}`);
    }
  }

  const clickTile = (id, e) => {
    if (e.target.tagName === 'I' || e.target.tagName === 'BUTTON') {
      e.preventDefault();
    } else {
      const ele = e.target.closest(`#tile_${id}`);
      pushTileClickData(ele);
    }
  }

  const pushTileClickData = (ele) => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      'event': 'select_item',
      'home_type': ele.dataset.homeType,
      'care_level': ele.dataset.careLevel,
      'care_type': ele.dataset.careTypes,
      'care_rooms': ele.dataset.careRooms,
      'item_list_type': ele.dataset.type,
      'item_list_id': ele.dataset.listId,
      'item_list_name': ele.dataset.listName,
      'district': ele.dataset.filterDistrict,
      'suburb': ele.dataset.filterSuburb,
      'items': {
        'item_id': ele.dataset.modalId,
        'item_name': ele.dataset.title,
        'currency': 'NZD',
        'index': parseInt(ele.dataset.position, 10),
        'item_brand': ele.dataset.operatorName,
        'item_category': ele.dataset.type,
        'item_category2': ele.dataset.typesOfHomes,
        'item_category3': ele.dataset.subscription,
        'item_category4': ele.dataset.region,
        'item_category5': `${ele.dataset.district} ${ele.dataset.suburb}`,
        'item_variant': ele.dataset.operatorId,
        quantity: 1,
      },
    });
  }

  const showServerSideValidateErrors = (error, isSubmitting, confirmation) => {
    if (error.response) {
      isSubmitting.value = false;

      confirmation.class = 'message--danger'
      const errors = error.response.data.errors;

      for (let i in errors) {
        confirmation.message = errors[i][0];
      }
    }
  }

  const enquirySubmitDataLayer = (form) => {
    let type = form.getElementsByClassName('enquiry_type')[0].value;
    let typeFull = form.getElementsByClassName('enquiry_type_full')[0].value;

    if (type === 'typesOfHome') {
      type = 'village';
    }

    if (type === 'property') {
      type = 'homes for sale';
    }

    if (type === 'care-home') {
      type = 'care home'
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'enquiry',
      'enquiry_type': typeFull,
      'items': {
        item_id: form.getElementsByClassName('enquiry_type_id')[0].value,
        item_name: form.getElementsByClassName('property_name')[0].value,
        currency: 'NZD',
        index: '1',
        item_brand: form.getElementsByClassName('operator_name')[0].value,
        item_category: type,
        item_category2: form.getElementsByClassName('home_types').length > 0 ?
          form.getElementsByClassName('home_types')[0].value : '',
        item_category3: form.getElementsByClassName('subscription')[0].value,
        item_category4: form.getElementsByClassName('enquiry_region')[0].value,
        item_category5: form.getElementsByClassName('enquiry_district')[0].value,
        item_variant: form.getElementsByClassName('operator_id')[0].value,
        quantity: 1
      },
    });

    // push to loopa
    window.loopa = window.loopa || [];
    window.loopa.push({
      event: 'conversion',
      data: {
        products: form.getElementsByClassName('enquiry_type_id')[0].value,
        ProductId: form.getElementsByClassName('enquiry_type_id')[0].value,
        value: 0,
        type: type,
        HousingType: type,
        currency: 'NZD',
        productName: form.getElementsByClassName('property_name')[0].value,
        operatorName: form.getElementsByClassName('operator_name')[0].value,
        Region: form.getElementsByClassName('enquiry_region')[0].value,
        District: form.getElementsByClassName('enquiry_district')[0].value,
      }
    });
  }

  const sendFBLeadData = (contentName) => {
    fbq('track', 'Lead', {
      content_name: contentName,
    });
  }

  const saveRemoveFavourite = (event, type, type_id, isAuth) => {
    if (isAuth === false || isAuth === null) {
      globalStore.setModal(
        {
          name: 'loginModal',
          showFooter: true,
        }
      )

      return;
    }

    let text = '';
    axios.post('/save-remove-item', {
      type: type,
      type_id: type_id,
      _token: document.head.querySelector('[name~=csrf-token][content]').content,
    }).then(function (response) {
      const added = response.data.added;
      let refreshAfterClose = false;

      if (added === true) {
        text = 'Saved to your list';
        event.target.parentElement.classList.add('tile__favourite--selected');
      } else {
        text = 'Removed from your list';
        refreshAfterClose = true;
        event.target.parentElement.classList.remove('tile__favourite--selected');
      }

      let modalName = 'successFavouriteModal';

      if (response.data.showInitialModal) {
        modalName = 'successFavouriteInitialModal'
      }

      globalStore.setModal(
        {
          name: modalName,
          showFooter: false,
          title: text,
          refreshAfterClose: refreshAfterClose,
        }
      )
    }).catch(error => {
      showServerSideValidateErrors(error, isSubmitting, confirmation)
    });
  }

  return {
    assignHiddenFields,
    hideModal,
    showEventRegisterForm,
    blogDownloadForm,
    showPropertyListModal,
    toggleEnquiryForm,
    toggleModal,
    pushTileClickData,
    closeModal,
    showServerSideValidateErrors,
    clickTile,
    enquirySubmitDataLayer,
    sendFBLeadData,
    saveRemoveFavourite,
  }
}
